export default "__VITE_ASSET__CKuBKqFy__"